import { render, staticRenderFns } from "./ClueDisplay.vue?vue&type=template&id=ba8c3332&scoped=true"
import script from "./ClueDisplay.vue?vue&type=script&lang=js"
export * from "./ClueDisplay.vue?vue&type=script&lang=js"
import style0 from "./ClueDisplay.vue?vue&type=style&index=0&id=ba8c3332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8c3332",
  null
  
)

export default component.exports